<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="110px" :rules="rules">
				<el-row>
					<el-col :span="12">
						<el-form-item label="缴费人手机:" prop="snm">
							<el-input v-model="formParameter.snm"  placeholder="输入手机自动匹配报考"
								@input="payer($event)"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="缴费人:" prop="name">
							<el-input :readonly="true" v-model="formParameter.name" 
								disabled></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="报读:" prop="stuid">
							<el-select v-model="formParameter.stuid" @change="chg" placeholder="请选择">
								<el-option v-for="item in signArr" :key="item.id" :label="item.school" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="缴费时间:" prop="gntm">
							<el-date-picker v-model="formParameter.gntm" type="datetime" value-format="yyyy-MM-dd HH:mm"
								placeholder="选择日期时间">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="缴费类型:" prop="subtype">
							<select-option-dictionary v-model="formParameter.subtype"
								dkey="jf-type"></select-option-dictionary>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="缴费金额:" prop="cost"><el-input v-model="formParameter.cost"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="跟进人:" prop="type">
							<el-select v-model="formParameter.username" placeholder="请选择">
								<el-option v-for="item in allEmps" :key="item.id" :label="item.name" :value="item.name">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="24">
						<el-form-item label="缴费记录:" prop="records"><el-input type="textarea" v-model="formParameter.records"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="formParameter.shouju">
					<el-col :span="24">
						<el-image style="width: 600px; height: 300px;margin-left: 50px;" :src="baseURI+formParameter.shouju"
							:preview-src-list="srcList">
						</el-image>
						<i style="margin-left: 10px;" class="el-icon-circle-close" @click="updateImg()"> </i>
					</el-col>
				</el-row>
				<el-row v-else>
					<el-form-item label="上传收据:" prop="fppic">
						<el-col :span="24" class="userHead" style="margin-left: 30px;">
							<drag-file-upload @change="change" v-model="formParameter.shouju" drag uri="/statics/shouju"
								model="fileSystem" :size="10240"></drag-file-upload>
							<div style="font-weight: bold;">
							</div>
						</el-col>
					</el-form-item>
				</el-row>

			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
			<el-button @click="close">取 消</el-button>

		</div>
	</popup>
</template>

<script>

import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/xueli/xlsturecord.js';
import apiUsr from '@/api/system/user/user.js';
import dragFileUpload from '@/components/biz/fileUpload/dragFileUpload.vue';
import constant from '@/util/constant.js';

export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary,
		dragFileUpload,
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			baseURI:constant.serverUrl,
			formParameter: { result: '已完成' },
			allEmps: [],   //备选员工
			signArr: [],
			srcList: [],
			rules: {
				snm: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				],
				gntm: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				],
				content: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				], cost: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				], subtype: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				]
			}

		}
	},
	methods: {
		chg() {
			this.$forceUpdate()
		},
		change() {
			if(this.formParameter.shouju && this.formParameter.shouju.indexOf('/statics/')>0 ){
				  this.formParameter.shouju = this.formParameter.shouju.substring( this.formParameter.shouju.indexOf('/statics/') ) 
				}
		      },
		payer(e) {
			if (this.formParameter.snm && this.formParameter.snm.length == '11') {

				let parameter = { mobile: this.formParameter.snm };
				api.autoSnmBymobile(parameter, response => {
					if (response.data && response.data.length > 0) {
						this.signArr = response.data
						this.formParameter.stuid = this.signArr[0].id
						this.formParameter.name = this.signArr[0].name;
					} else {
						this.signArr = []
						this.formParameter.stuid = ''
						this.formParameter.name = ''
					}


					//setTimeout(this.$forceUpdate(), 10);
				})

			}

		},
		//打开弹框
		open(parameter, title, disabled, size) {
			this.parameter = parameter;
			this.disabled = disabled;
			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
				this.init();
			})
		},
		//关闭弹框
		close() {
			this.disabled = false;
			//reset
			this.formParameter = {}
			this.$refs.popup.close();
		},
		//更新图片
		updateImg() {
			this.formParameter.shouju = null;
		},
		//提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;

				

				if (!this.parameter.id) {
					//添加
					let parameter = this.$utils.merger(this.formParameter);
					parameter.type = "缴费",
						parameter.gnneedtm = parameter.gntm,
						console.log('parameter', parameter);
					api.addRcd(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				} else {
					//编辑
				

					let parameter = this.$utils.merger(this.formParameter);
					api.update(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				}
			});
		},
		init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			// //清空内容
			this.formParameter = {result: '已完成' };
			this.signArr = [];
			//清楚校验
			this.$refs.form.clearValidate();
			apiUsr.listAllEmps({}, res => {
				this.allEmps = res.data
				if (this.parameter.id) {
					//编辑查询数据
					let parameter = {
						id: this.parameter.id
					};
					api.toUpdate(parameter, response => {
						this.formParameter = response.data;
						this.formParameter.snm = this.parameter.moblie;
						this.payer(this.formParameter.snm)
						this.popupLoading = false;
					});
				} else {
					//添加
					this.popupLoading = false;
				}

			})


		}
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
